import React from 'react';
import './Sidebar.css';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { 
  FaHome, 
  FaClipboardList, 
  FaBox, 
  FaUsers, 
  FaTags, 
  FaMapMarkerAlt, 
  FaTicketAlt, 
  FaArchive, 
  FaBars, 
  FaShoppingCart, 
  FaImage, 
  FaClock, 
  FaTshirt 
} from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom'; 

const Sidebar = () => {
  const { isCollapsed, toggleSidebar } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location

  const SidebarData = [
    { icon: FaClipboardList, heading: "Users", path: "/" }, // Most important
    { icon: FaShoppingCart, heading: "Orders", path: "/order-management" }, // Important
    { icon: FaBox, heading: "Products+", path: "/createproducts" }, // Important
    { icon: FaTags, heading: "Category+", path: "/createcategory" }, // Important
    { icon: FaTshirt, heading: "Filters", path: "/filters" }, // Colours / sizes / price / type — the storefront filter panel
    { icon: FaTicketAlt, heading: "Coupon+", path: "/coupon-management" }, // Important
    { icon: FaMapMarkerAlt, heading: "Pincode+", path: "/create-pincode" }, // Important
    { icon: FaHome, heading: "Homepage+", path: "/homepage-manager" },
    { icon: FaImage, heading: "Hero Media+", path: "/hero-section" }, // Less important
    { icon: FaClock, heading: "Count Down+", path: "/create-count-down" }, // Less important
    { icon: FaArchive, heading: "Archive+", path: "/createarchive" }, // Less important
    { icon: FaBars, heading: "Marquee+", path: "/marquee-management" }, // Less important
    { icon: FaShoppingCart, heading: "Trial Order", path: "/trail-order-management" }, // Least important
  ];

  const handleClick = (path) => {
    navigate(path);
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-menu">
        {SidebarData.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className={`menu-item ${location.pathname === item.path ? 'active' : ''}`} // Add 'active' class if the path matches
            onClick={() => handleClick(item.path)}
          >
            <item.icon size={20} className="menu-icon" />
            {!isCollapsed && <span className="menu-text">{item.heading}</span>}
          </Link>
        ))}
      </div>
      <div className="sidebar-footer">
        <button className="toggle-button" onClick={toggleSidebar}>
          {isCollapsed ? 'Expand' : 'Collapse'}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;